import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import Admin from "src/types/Admin.type";

const hasCompany = (user?: Admin): boolean => !!user && !_isEmpty(_get(user, "Company"));

export default hasCompany;